import { FunctionComponent, RefObject } from "react";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import styles from "./navButton.module.scss";
import { MenuContext } from "providers/MenuProvider";

const scrollTo = (
  ref: RefObject<HTMLDivElement>,
  setIsHamburgerMenuOpen: (newState: boolean) => void
) => {
  if (ref && ref.current /* + other conditions */) {
    const refTopPosition = ref.current.getBoundingClientRect().top;
    const scrollWrapper = document.querySelector(".scrollWrapper");
    setIsHamburgerMenuOpen(false); // close hamburgerMenu on navigate/scroll to

    const scrollWrapperTopPosition = scrollWrapper?.scrollTop ?? 0;
    const destinationTopPosition = scrollWrapperTopPosition + refTopPosition;

    scrollWrapper?.scrollTo({
      top: destinationTopPosition,
      behavior: "smooth",
    });
  }
};

const NavButton: FunctionComponent<{
  title: string;
  className?: string;
  currRef: RefObject<HTMLDivElement>;
}> = ({ title, className = "", currRef }) => {
  return (
    <MenuContext.Consumer>
      {(state) => (
        <button
          onClick={() => scrollTo(currRef, state.setIsHamburgerMenuOpen)}
          className={`${styles.navButton} ${className}`}
          aria-label="nav-menu"
        >
          <p>{title}</p>
          <ArrowDropDownIcon />
        </button>
      )}
    </MenuContext.Consumer>
  );
};

export default NavButton;
